import React, { Suspense, lazy, Fragment, useState, useEffect } from "react";
import { Route, Redirect, Switch, useLocation, useHistory } from "react-router-dom";
import Loader from "react-loaders";
import Login from "../../pages/Login/login"; // Import Login component

// Immediately rehydrate sessionStorage from sharedSession if available.
(function rehydrateSession() {
  const sharedSession = localStorage.getItem("sharedSession");
  if (sharedSession) {
    const sessionData = JSON.parse(sharedSession);
    console.log("Rehydrating session in new tab:", sessionData);
    Object.keys(sessionData).forEach((key) => {
      sessionStorage.setItem(key, sessionData[key]);
    });
    localStorage.removeItem("sharedSession");
  }
})();

const UserPages = lazy(() => import("../../pages/UserPages"));
const Applications = lazy(() => import("../../pages/Applications"));
const Dashboards = lazy(() => import("../../pages/Dashboards"));
const Widgets = lazy(() => import("../../pages/Widgets"));
const Components = lazy(() => import("../../pages/Components"));
const Charts = lazy(() => import("../../pages/Charts"));
const Forms = lazy(() => import("../../pages/Forms"));
const Tables = lazy(() => import("../../pages/Tables"));
const AddUsers = lazy(() => import("../../pages/CreateCompany"));
const AddPersonnel = lazy(() => import("../../pages/CreatePersonnel"));
const Qrcode = lazy(() => import("../../pages/QRCODE"));
const Points = lazy(() => import("../../pages/Points"));
const Reports = lazy(() => import("../../pages/Reports"));
const Records = lazy(() => import("../../pages/Records"));
const PersonalDashBoard = lazy(() => import("../../pages/PersonalDashBoard"));
const GiftScheme = lazy(() => import("../../pages/Scheme"));
const GiftManagementElectrician = lazy(() => import("../../pages/Giftmanagementelectrician"));
const giftmanagementDealer = lazy(() => import("../../pages/Giftmanagementdealer"));
const UploadPoints = lazy(() => import("../../pages/uploadpoints"));
const RequestForm = lazy(() => import("../../pages/Form"));
const SaleOrders = lazy(() => import("../../pages/SaleOrders"));
const AppMain = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    sessionStorage.getItem("adminId") ? true : false
  );
  const location = useLocation();
  const history = useHistory();  // Use history to manage navigation

  useEffect(() => {
    const handleStorageChange = () => {
      setIsAuthenticated(sessionStorage.getItem("adminId") ? true : false);
    };
    window.addEventListener("storage", handleStorageChange);

    // Prevent back navigation to login page when already authenticated
    if (isAuthenticated && location.pathname === "/login") {
      history.replace("/dashboards/crm");  // Redirect to the dashboard
    }

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [isAuthenticated, location, history]);

  const handleLogin = () => {
    setIsAuthenticated(true);
    window.dispatchEvent(new Event("storage"));
    history.replace("/dashboards/crm");  // Redirect immediately after login
  };

  if (!isAuthenticated && location.pathname !== "/login") {
    return <Redirect to="/login" />;
  }

  return (
    <Fragment>
      <Switch>
      {!isAuthenticated ? (
          <Route path="/login" render={() => <Login onLogin={handleLogin} />} />
        ) : (
          <>
            <Suspense
              fallback={
                <div className="loader-container">
                  <div className="loader-container-inner">
                    <div className="text-center">
                      <Loader type="ball-pulse-rise" />
                    </div>
                    <h6 className="mt-5">Please wait....</h6>
                  </div>
                </div>
              }
            >
              <Route path="/components" component={Components} />
              <Route path="/forms" component={Forms} />
              <Route path="/records" component={Records} />
              <Route path="/qrcode" component={Qrcode} />
              <Route path="/points" component={Points} />
              <Route path="/charts" component={Charts} />
              <Route path="/reports" component={Reports} />
              <Route path="/tables" component={Tables} />
              <Route path="/addcompany" component={AddUsers} />
              <Route path="/addpersonnel" component={AddPersonnel} />
              <Route path="/widgets" component={Widgets} />
              <Route path="/pages" component={UserPages} />
              <Route path="/apps" component={Applications} />
              <Route path="/giftscheme" component={GiftScheme} />
              <Route path="/dashboards" component={Dashboards} />
              <Route path="/personaldashboard" component={PersonalDashBoard} />
              <Route path="/giftmanagementelectirician" component={GiftManagementElectrician} />
              <Route path="/giftmanagementDealer" component={giftmanagementDealer} />
              <Route path="/uploadPoints" component={UploadPoints} />
              <Route path="/reportform" component={RequestForm} />          
              <Route path="/saleorders" component={SaleOrders} />   
            </Suspense>
            <Route exact path="/" render={() => <Redirect to="/dashboards/crm" />} />
          </>
        )}
      </Switch>
    </Fragment>
  );
};

export default AppMain;
